module.exports = __webpack_public_path__ + "img/noole-riba-pikk.571b8143.svg";